import {Box, Button, HStack, Text, VStack} from '@chakra-ui/react';
import {ModaleLayout} from '@/components/Modale/ModaleLayout';
import {Trans, useTranslation} from 'react-i18next';
import {BlueButton} from '@/components/Button/BlueButton';
import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {FaceIcon} from '@/components/svg/FaceIcon';

interface ConfirmationDegradationPrixMetierModalProps {
  onConfirm: () => void;
  onCancel?: () => void;
}

/**
 * Modale de confirmation de la dégradation d'un prix métier (catégorie C).
 */
export const ConfirmationDegradationPrixMetierModal =
  NiceModal.create<ConfirmationDegradationPrixMetierModalProps>(
    ({onConfirm, onCancel}) => {
      const {t} = useTranslation();
      const modal = useModal();

      const handleConfirm = () => {
        onConfirm();
        modal.hide();
      };

      const handleCancel = () => {
        onCancel?.();
        modal.hide();
      };

      return (
        <ModaleLayout
          visible={modal.visible}
          hide={handleCancel}
          titre={t(
            'back_office.prise_de_commande.panier.confirmation_degradation_prix_metier.titre',
          )}
          size_desktop='xl'
          footer={
            <HStack
              width='100%'
              justifyContent='center'
              spacing={5}
            >
              <Button
                color='gray.dark'
                variant='ghost'
                height='40px'
                onClick={handleCancel}
              >
                {t(
                  'back_office.prise_de_commande.panier.confirmation_degradation_prix_metier.annuler',
                )}
              </Button>
              <BlueButton
                borderRadius='12px'
                height='40px'
                marginTop={0}
                onClick={handleConfirm}
                texte={t(
                  'back_office.prise_de_commande.panier.confirmation_degradation_prix_metier.degrader',
                )}
              />
            </HStack>
          }
        >
          <VStack
            align='stretch'
            spacing={5}
            py={2}
          >
            <Text
              fontWeight='700'
              fontSize='md'
              textAlign='center'
            >
              {t(
                'back_office.prise_de_commande.panier.confirmation_degradation_prix_metier.question',
              )}
            </Text>
            <Box
              bg='blue.main_transparency_10'
              borderRadius='12px'
              p={4}
            >
              <HStack spacing={3}>
                <Box
                  bg='white'
                  p={2}
                  borderRadius='8px'
                  display='flex'
                  alignItems='center'
                  justifyContent='center'
                >
                  <FaceIcon
                    width='20px'
                    height='20px'
                    color='blue.500'
                  />
                </Box>
                <Text
                  fontSize='xs'
                  color='blue.500'
                  lineHeight='1.5'
                >
                  <Trans
                    i18nKey='back_office.prise_de_commande.panier.confirmation_degradation_prix_metier.info'
                    components={{
                      bold: (
                        <Text
                          as='span'
                          fontWeight='700'
                        />
                      ),
                    }}
                  />
                </Text>
              </HStack>
            </Box>
          </VStack>
        </ModaleLayout>
      );
    },
  );
